import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

import {
  FieldInput,
  FieldError
} from '@CS/components/Form/InputField/InputField.styles';

export const UsernameTitle = styled.h3`
  color: ${Theme.color.white};

  margin-bottom: 30px;
  text-align: center;
  position: relative;

  line-height: 120%;
  font-weight: 700;
  font-size: 25px;

  display: block;
  height: auto;
  width: 100%;
`;

type InputContainerAttributes = {
  $error?: boolean;
  $bold?: boolean;
};

export const InputContainer = styled.div<InputContainerAttributes>(
  ({ $error, $bold }) => css`
    border: 2px solid ${$error ? Theme.color.error : 'transparent'};
    background-color: ${Theme.color.white};

    > button:last-child > svg > path {
      stroke: ${$bold ? Theme.color.white : Theme.color.black};
    }

    border-radius: 100px;
    align-items: center;
    position: relative;
    max-width: 424px;

    display: flex;
    padding: 5px;
    height: 70px;
    width: 100%;
  `
);

type UsernameAttributes = {
  $bold?: boolean;
};

export const UsernameInput = styled(FieldInput)<UsernameAttributes>(
  ({ $bold }: UsernameAttributes) => css`
    &&& {
      font-style: ${Theme.font.style.italic};
      background-color: transparent;
      border: none;

      ${$bold &&
      css`
        font-weight: ${Theme.font.weight.bold};
      `}
    }
  `
);

export const UsernameError = styled(FieldError)`
  color: ${Theme.color.error};
  position: absolute;
  top: 75px;

  &&& {
    margin: 0 0 -2rem;
  }
`;
